module.exports = __webpack_public_path__ + "prod/20251121165348/img/logo_200.6488dd39.png";